import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

type Props = {
  agentBio: string,
  className: string,
};

const AgentListings = ({ classes, className, agentBio }: Props) => {
  if (!agentBio || (agentBio && agentBio.trim() === "<p></p>")) {
    return null;
  }
  return (
    <div className={classNames(classes.root, className)}>
      <Typography type="heading4" className={classes.bioHeading}>
        About
      </Typography>
      <div
        className={classes.bio}
        dangerouslySetInnerHTML={{ __html: agentBio }}
      />
    </div>
  );
};
export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    margin: "24px auto 96px auto",
  },
  bioHeading: {
    marginBottom: theme.spacing.unit * 0.75,
  },
  bio: {
    color: theme.colors.gray700,
    fontSize: "18px",
    lineHeight: "1.6",

    "& h1": {
      color: "#121130",
      fontWeight: "700",
      letterSpacing: ".2px",
      fontSize: "32px",
      marginTop: "44px",
      marginBottom: "12px",
    },

    "& h2": {
      fontSize: "26px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h3": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h4": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h5": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& h6": {
      fontSize: "21px",
      fontWeight: "700",
      marginBottom: theme.spacing.unit * 2,
      marginTop: theme.spacing.unit * 0.75,
    },

    "& a": {
      color: theme.colors.black,
      textDecoration: "underline",
    },

    "& ol": {
      position: "relative",
      counterReset: "item",
    },

    "& ol li": {
      counterIncrement: "item",
      paddingLeft: theme.spacing.unit * 1.5,

      "&:before": {
        content: 'counter(item) "."',
        position: "absolute",
        left: "0",
        fontWeight: "700",
      },
    },

    "& ul": {
      listStyleType: "disc",
    },

    "& ul li": {
      marginLeft: theme.spacing.unit,
    },

    "& p": {
      marginTop: theme.spacing.unit * 0.25,
      marginBottom: theme.spacing.unit * 0.5,
    },

    "& img": {
      display: "block",
      maxWidth: "100%",
      marginBottom: theme.spacing.unit,
    },

    "& img[alt='This Old House']": {
      width: "120px",
    },

    "& b": {
      fontWeight: "600",
    },

    "& strong": {
      fontWeight: "600",
    },
  },
}))(AgentListings);
